import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      <nav className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex items-center gap-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/31a8f353fecb75fc1f2431fc02e10c33.png"
                alt="ELEGANCE STAFFING"
                className="h-16 w-auto"
              />
            </a>

            <div className="hidden lg:flex items-center gap-8">
              <a href="#home" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>Home</a>
              <a href="#about-us" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>About Us</a>
              <a href="#services" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>Services</a>
              <a href="#gallery" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>Gallery</a>
              <a href="#testimonials" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>Testimonials</a>
              <a href="#job-request" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>Request a Job</a>
              <a href="#contact" className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}>Contact</a>
            </div>

            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`lg:hidden p-2 rounded-lg transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setIsMenuOpen(false)}></div>
          <div className="absolute top-20 right-0 left-0 bg-white shadow-xl">
            <div className="flex flex-col p-6 space-y-4">
              <a href="#home" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">Home</a>
              <a href="#about-us" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">About Us</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">Services</a>
              <a href="#gallery" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">Gallery</a>
              <a href="#testimonials" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">Testimonials</a>
              <a href="#job-request" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">Request a Job</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)} className="text-gray-900 hover:text-[#D4AF37] font-semibold py-2 cursor-pointer">Contact</a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
